import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const valueWrapper: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  alignSelf: 'center',
  justifyContent: 'center',
  width: (p) => p.spacing(2),
  height: (p) => p.spacing(2),
  borderRadius: '50%',
  background: (p) => p.palette.success[200],
  cursor: 'pointer',
};
